export default __webpack_public_path__ + "static/media/alliance_im03.c515f023.png";